import { InfoOutlined } from '@mui/icons-material';
import { Box, Skeleton, Typography, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import * as S from '../styles';

interface RenderBigNumbersSessionsProps {
  completedSessions: number | undefined;
  completedSessionsWithMe: number | undefined;
  isLoading: boolean;
}

export const RenderBigNumbersSessions: React.FC<RenderBigNumbersSessionsProps> =
  ({ completedSessions, completedSessionsWithMe, isLoading }) => {
    const intl = useIntl();

    if (isLoading) {
      return (
        <S.BigNumbers>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="rectangular" width="40px" height="40px" />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginTop="4px"
          >
            <Skeleton variant="rectangular" width="150px" height="24px" />
          </Box>
        </S.BigNumbers>
      );
    }

    return (
      <S.BigNumbers>
        <Typography variant="h4">{completedSessions}</Typography>
        <S.BigNumbersLabel>
          <FormattedMessage id="CAREMATRIXCPTC.SESSIONS.COMPLETE" />
          <Tooltip
            title={intl.formatMessage(
              { id: 'CAREMATRIXCPTC.TOOLTIP.SESSIONSCOMPLETE' },
              { number: completedSessionsWithMe },
            )}
            arrow
            placement="top"
          >
            <InfoOutlined />
          </Tooltip>
        </S.BigNumbersLabel>
      </S.BigNumbers>
    );
  };
